export default __webpack_public_path__ + "467c3ad51b2b5a8878bf521d63b656d7.png";